// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__iwt7i","toolbarMessage":"banner_toolbarMessage__f4PSm","closeIcon":"banner_closeIcon__Eetux"};